import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/mythos/`;

class cdoMythos {
    selectAll = (callback) => {
        util.getJSON(`${servicesURL}select-all`, callback);
    }
}

const cdo = new cdoMythos();
export default cdo;
